import XLSX from 'sheetjs-style';
import { sToHMSColonSeparated } from '../../../helpers';

const OvertimeReportExcel = (overtimeData, currency) => {
  const wb = XLSX.utils.book_new();
  const excelRows = [];
  const cur = currency ? ` (${currency})` : '';

  const subHeading = [
    'Team Member',
    'Logged Hours',
    'Overtime',
    `Regular Time Pay${cur}`,
    `OT Pay${cur}`,
    `Gross Pay${cur}`,
  ];

  overtimeData
    .sort((a, b) => (a.user.firstName < b.user.firstName ? -1 : 1))
    .forEach((entry) => {
      excelRows.push({
        name: `${entry.user.firstName} ${entry.user.lastName || ''}`,
        loggedHours: sToHMSColonSeparated(
          Math.round(entry.workSessionHours * 60 * 60)
        ),
        overtime: sToHMSColonSeparated(
          Math.round(entry.overTimeHours * 60 * 60)
        ),
        regularPay: entry.regularPay ? entry.regularPay.toFixed(2) : '0.00',
        otPay: entry.overTimePay ? entry.overTimePay.toFixed(2) : '0.00',
        grossPay:
          entry.overTimePay || entry.regularPay
            ? (entry.overTimePay + entry.regularPay).toFixed(2)
            : '0.00',
      });
    });

  const ws = XLSX.utils.json_to_sheet(excelRows, {
    skipHeader: true,
    origin: 'A2',
  });

  XLSX.utils.sheet_add_aoa(ws, [subHeading], {
    skipHeader: true,
    origin: 'A1',
  });

  const range = XLSX.utils.decode_range(ws['!ref']);

  for (let C = 0; C < 26; C += 1) {
    const cellAddress = { c: C, r: 0 };
    const cellRef = XLSX.utils.encode_cell(cellAddress);
    if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
    ws[cellRef].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'dddddd' } },
    };
  }

  const totalColumns = range.e.c + 1;
  ws['!cols'] = Array(totalColumns).fill({ wpx: 100 });

  XLSX.utils.book_append_sheet(wb, ws, 'Overtime Report');
  XLSX.writeFile(wb, 'overtime_report.xlsx');
};

export default OvertimeReportExcel;
